popupOverlay = document.querySelector(".popup-overlay__wrapper");
popupContainer = document.querySelector(".popup-overlay__container"); 
popupContainerDropdown = document.querySelector(".popup-overlay__container.dropdown-container");
popupContainerNonShippable = document.querySelector(".popup-overlay__container.non-shippable-container"); 
popupContainerEmailSignup = document.querySelector(".popup-overlay__container.email-signup-container"); 
popupContainerCustomerRegistration = document.querySelector(".popup-overlay__container.customer-registration-container"); 
popupContainerCustomerRegistrationShippable = document.querySelector(".popup-overlay__container.customer-registration-shippable-container"); 
popupContainerCustomerRegistrationGeneral = document.querySelector(".popup-overlay__container.customer-registration-general-container"); 
popupContainerTooltip = document.querySelector(".popup-overlay__container .tooltip-icon"); 
customerRegistrationStateInput = document.querySelector("input[data-register-state]"); 

closeBtn = $(".close-btn");
closeBtnGeneral = $(".customer-registration-general-container .close-btn");
locationBtn = $('.header__icon-touch--location');
locationBadge = $('.header__location-badge');
const joinBtn = $('.join-community');
let $klaviyoEmailInput;
const klaviyoTooltip = '<div class="tooltip-container"><button type="button" class="tooltip-icon inside-input" aria-label="By submitting your email, you are agreeing that Schwan\'s and/or its affiliates may contact you via email with promotional offers, updates, and other information consistent with our Privacy Notice. You may withdraw your consent at any time. Tab ahead to read Privacy Notice."><span class="icon"><svg width="100%" viewBox="0 0 24 24"><path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm0 18.25c-.69 0-1.25-.56-1.25-1.25s.56-1.25 1.25-1.25c.691 0 1.25.56 1.25 1.25s-.559 1.25-1.25 1.25zm1.961-5.928c-.904.975-.947 1.514-.935 2.178h-2.005c-.007-1.475.02-2.125 1.431-3.468.573-.544 1.025-.975.962-1.821-.058-.805-.73-1.226-1.365-1.226-.709 0-1.538.527-1.538 2.013h-2.01c0-2.4 1.409-3.95 3.59-3.95 1.036 0 1.942.339 2.55.955.57.578.865 1.372.854 2.298-.016 1.383-.857 2.291-1.534 3.021z" fill="currentColor"></path></svg></span><span class="tooltip fs-body-small">By submitting your email, you are agreeing that Schwan\'s and/or its affiliates may contact you via email with promotional offers, updates, and other information consistent with our <a tabindex="-1" href="/pages/privacy-notice">Privacy Notice</a>. You may withdraw your consent at any time.</span></button></div><a class="sr-only" href="/pages/privacy-notice">Privacy Notice</a>';

userLocation = JSON.parse(window.localStorage.getItem('user_location'));
nonShippablePopupShown = JSON.parse(window.localStorage.getItem('non_shippable_popup_shown'));
shippablePopupShown = JSON.parse(window.localStorage.getItem('shippable_popup_shown'));

$(function() {
  $(document).ready(function() {

    /* 
    Start: Uncomment for limited distribution 
    // Open popup on load
    if (userLocation == null) {
      closeBtn.hide();

      setTimeout(() => { 
        initPopup();
      }, 1000);
    } else {
      locationBadge.addClass("is-visible");
      locationBadge.text(userLocation.state_abbreviation).prepend('<span class="sr-only">Selected state in abbreviated form: </span>');

      if (!userLocation.shippable && !nonShippablePopupShown) {
        setTimeout(() => { 
          initCustomerRegistrationPopup();

          // Add tooltip here since it can't be added in Klaviyo
          $klaviyoEmailInput = $('.customer-registration-container form.klaviyo-form input').first().after( klaviyoTooltip );

          localStorage.setItem('non_shippable_popup_shown', true);
        }, 1000);
      } else if (userLocation.shippable && !shippablePopupShown) {
        setTimeout(() => { 
          initCustomerRegistrationShippablePopup();
          // Add tooltip here since it can't be added in Klaviyo
          $klaviyoEmailInput = $('.customer-registration-shippable-container form.klaviyo-form input').first().after( klaviyoTooltip );

          localStorage.setItem('shippable_popup_shown', true);
        }, 1000);
      }
    }
    End: Uncomment for limited distribution 
    */

    /* Start: Remove/comment out for limited distribution */
    if (!shippablePopupShown) {
      setTimeout(() => { 
        initCustomerRegistrationShippablePopup();
        $klaviyoEmailInput = $('.customer-registration-shippable-container form.klaviyo-form input').first().after( klaviyoTooltip );
        localStorage.setItem('shippable_popup_shown', true);
      }, 1000);
    }
    /* End: Remove/comment out for limited distribution */

    // General Form
    joinBtn.on("click", function(e){
      e.preventDefault();
      setTimeout(() => { 
        initCustomerRegistrationGeneralPopup( $(this) );
        // Add tooltip here since it can't be added in Klaviyo
        $klaviyoEmailInput = $('.customer-registration-general-container form.klaviyo-form input').first().after( klaviyoTooltip );
      }, 1000);
    });

  })
})

function initPopup() {
  initDropdown();
  popupOverlay.classList.add("is-active");
  popupContainerDropdown.classList.add("is-active");
  popupContainerDropdown.querySelector(".close-btn").focus();
}

function closePopup() {
  popupOverlay.classList.remove("is-active");
  popupContainerDropdown.classList.remove("is-active");
  popupContainerCustomerRegistration.classList.remove("is-active");
  popupContainerCustomerRegistrationShippable.classList.remove("is-active");
  popupContainerCustomerRegistrationGeneral.classList.remove("is-active");
  popupContainerNonShippable.remove("is-active");
  popupContainerEmailSignup.classList.remove("is-active");
  locationBtn.focus();
}

function closeGeneralPopup() {
  popupContainerCustomerRegistrationGeneral.classList.remove("is-active");
}

// Open popup on icon click
locationBtn.click(function() {
  closeBtn.show();
  initPopup();
});

// Close popup
closeBtn.click(function() {
  closePopup();
})

// Close General Popup
closeBtnGeneral.click(function() {
  let popupSource = $(".popup-overlay__container.customer-registration-general-container .close-btn").attr("data-popup-source");
  $('.join-community[data-join-community-source="'+popupSource+'"]').focus();
  closeGeneralPopup();
})

// Show customer registration if non-shippable state selected 
function initCustomerRegistrationPopup() { 
  popupOverlay.classList.add("is-active");
  popupContainerCustomerRegistration.classList.add("is-active");
  // customerRegistrationStateInput.value = userLocation.state_name;
  closeBtn.show();
  popupContainerCustomerRegistration.querySelector(".close-btn").focus();
}

function initCustomerRegistrationShippablePopup() { 
  popupOverlay.classList.add("is-active");
  popupContainerCustomerRegistrationShippable.classList.add("is-active");
  closeBtn.show();
  popupContainerCustomerRegistrationShippable.querySelector(".close-btn").focus();
}

function initCustomerRegistrationGeneralPopup(popupLink) { 
  let joinCommunitySource = popupLink.data("join-community-source");
  popupOverlay.classList.add("is-active");
  popupContainerCustomerRegistrationGeneral.classList.add("is-active");
  closeBtn.attr("data-popup-source", joinCommunitySource);
  closeBtn.show();
  popupContainerCustomerRegistrationShippable.querySelector(".close-btn").focus();
}

// Show newsletter signup
function initNonShippablePopup() { 
  popupOverlay.classList.add("is-active");
  popupContainerNonShippable.classList.add("is-active");
  closeBtn.show();
  popupContainerNonShippable.querySelector(".close-btn").focus();
}

// Show email signup
function initEmailSignupPopup() {
  popupOverlay.classList.add("is-active");
  popupContainerEmailSignup.classList.add("is-active");
  closeBtn.show();
  popupContainerEmailSignup.querySelector(".close-btn").focus();
}